import { render } from "./IconBook.vue?vue&type=template&id=f9f3a08a"
import script from "./IconBook.vue?vue&type=script&lang=js"
export * from "./IconBook.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__